import { FC, useEffect, useState } from 'react';
import { Box, Drawer, Slide } from '@mui/material';
import { useBreakpoints } from '@frontend/features/common/hooks/useBreakpoints';
import { GetMeDTO } from '@bandido/shared/dtos';
import { ProfileEditor } from './ProfileEditor';
import { ChangePassword } from './ChangePassword';

interface Props {
  isOpen: boolean;
  initialData: GetMeDTO | null;
  onClose?: () => void;
}

export const Profile: FC<Props> = ({ isOpen, onClose, initialData }) => {
  const [isEditingProfile, setIsEditingProfile] = useState(true);
  const { isSmallUp } = useBreakpoints();

  const toggleForms = () => {
    setIsEditingProfile((prev) => !prev);
  };

  useEffect(() => {
    let stateTimer: NodeJS.Timeout;
    if (!isOpen) {
      stateTimer = setTimeout(() => {
        setIsEditingProfile(true);
      }, 300);
    }
    return () => clearTimeout(stateTimer);
  }, [isOpen]);

  return (
    <Drawer anchor={isSmallUp ? 'right' : 'bottom'} open={isOpen} onClose={onClose}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'auto',
        }}
      >
        <Box position="relative" flex={1}>
          <Slide direction={isEditingProfile ? 'left' : 'right'} in={isEditingProfile} mountOnEnter unmountOnExit>
            <Box display={isEditingProfile ? 'flex' : 'none'} width="100%">
              <ProfileEditor initialData={initialData} switchToForm={toggleForms} onClose={onClose} />
            </Box>
          </Slide>
          <Slide direction={isEditingProfile ? 'right' : 'left'} in={!isEditingProfile} mountOnEnter unmountOnExit>
            <Box display={!isEditingProfile ? 'flex' : 'none'} width="100%">
              <ChangePassword switchToForm={toggleForms} />
            </Box>
          </Slide>
        </Box>
      </Box>
    </Drawer>
  );
};
